module.exports = __webpack_public_path__ + "static/media/wizualizacja-60.79694a85.png";